export const logConferenceActivity = (title: string, ...args) => {
  // it prevents removing console.log in production environment
  window.console.log(title, ...args);
};
